import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-box',
  templateUrl: './icon-box.component.html',
  styleUrls: ['./icon-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconBoxComponent {}
